import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Flame } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export default function Marquee() {
  const { t } = useLang();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  // horizontal parallax drift, coupled to page scroll
  const x = useTransform(scrollYProgress, [0, 1], [50, -50]);
  const items = t.marquee;

  const Row = ({ hidden }) => (
    <div aria-hidden={hidden || undefined} className="flex shrink-0 items-center">
      {items.map((word, i) => (
        <span key={i} className="flex items-center">
          <span className="whitespace-nowrap font-display italic text-2xl text-white/85 mx-8 sm:mx-14 sm:text-4xl">
            {word}
          </span>
          <Flame size={14} strokeWidth={1.6} className="shrink-0 text-gold" />
        </span>
      ))}
    </div>
  );

  return (
    <div
      ref={ref}
      className="relative overflow-hidden border-y border-gold/15 bg-coal py-6 sm:py-9"
      data-testid="marquee-band"
    >
      <motion.div style={{ x }} className="flex w-max">
        <div className="flex w-max animate-marquee">
          <Row />
          <Row hidden />
        </div>
      </motion.div>
    </div>
  );
}
